import React, { FC } from 'react';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

const StyledName = styled.h4`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  margin: 0 0 0 0;
  font-size: 15px;
  padding-right: 24px;
  line-height: 20px;

  ${media.md`
    font-size: 16px;
    padding-right: 0;
  `}
`;

type NameProps = {
  name: string;
};

export const Name: FC<NameProps> = ({ name }) => <StyledName>{name}</StyledName>;
